/* eslint-disable no-console */
import { Features } from 'common/constants/features';

import type { FeatureKey } from '../types';
import { isFeatureEnabled } from './isFeatureEnabled';

export const logEnabledFeatures = () => {
  console.log('*** Enabled features:');
  Object.entries(Features).forEach(([key]) => {
    console.log(`*** ${key}: ${isFeatureEnabled(key as FeatureKey)}`);
  });

  const version = window._env_.VITE_APP_TAG;
  const commit = window._env_.VITE_APP_COMMIT;
  console.log('*** Natter version:', version, commit ? `(${commit}) ***` : '***');
};
